"use client";
import React from "react";
import Hero from "@/components/Common/Hero";
import BrandWeBuy from "@/components/LuxuryWatches/BrandWeBuy";
import HowItWorks from "@/components/Common/HowItWorks";
import TrustedByMany from "@/components/Common/TrustedByMany";
import FeaturedOn from "@/components/Common/FeaturedOn";
import FAQ from "@/components/Common/FAQ";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
// import side from '../images/Hero/side.png';
// import BG from '../images/Hero/bg.png';
import { createClient } from "../../../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import SchemaScript from "@/components/SchemaScript";

const LuxuryWatches = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/what-we-buy/watch-buyers-nyc"
      />
      <SchemaScript data={pageData?.schema_json} />
      <Hero
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image.url || ""}
        backgroundImage={pageData?.hero_background_image}
        backgroundImageMobile={pageData?.hero_background_image_mobile}
        backgroundImageTab={pageData?.hero_background_image_tab}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        opacity={false}
        page={"Watch Buyers"}
      />
      <Breadcrumbs />
      <BrandWeBuy
        title={pageData?.brandwebuy_title || []}
        description={pageData?.brandwebuy_description || []}
        brandTitle={pageData?.brand_we_buy_tab_title || []}
        brandTabWatch={pageData?.brand_we_buy_tab_watch || {}}
      />
      <HowItWorks data={pageData} />
      <TrustedByMany data={commonComponents} page={"Watch Buyers"} />
      <FeaturedOn data={commonComponents} />
      <SliceZone slices={page?.data?.slices3} components={components} />
      <SliceZone slices={page?.data?.slices2} components={components} />
      <FreeAppraisal whiteBg={true} data={pageData} page={"Watch Buyers"} />
    </Layout>
  );
};

export default LuxuryWatches;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("luxury_watches");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
